/**
 * Possible types of icon button that affect what will be rendered.
 */
export enum IconButtonType {
    BUTTON,
    LINK
}
